import jwt_decode from 'jwt-decode';
import { jwtDecrypt } from 'jose';
import { COOKIE_NAME } from 'src/appConfig';
/**
 * Redirect to new Url
 *
 * @param url for new window
 */
export const openSite = (url) => {
  if (document.querySelector('#rough-water-seo-root')) {
    const channel = new BroadcastChannel('seo-space');
    channel.postMessage({
      message: 'open_new_tab',
      value: { url: url, id: '63ff3f35e8ab26111f2c1cf1' }
    });
  } else {
    window.open(url, '_blank');
  }
};

/**
 * Url sanitize
 *
 * @param url for token
 */
export const sanitizeURL = (url: string) => {
  let formateURL = url?.replace(/www./g, '');
  return formateURL;
};

/**
 * Set user token cookie
 *
 * @param authToken for token
 * @param checkDetail for user custom token details, if passed false then stop the call
 */
export function setCookieString(
  authToken: string,
  userName: string,
  checkDetail: boolean = true
) {
  const cookieString = `${COOKIE_NAME}=' + authToken + ';path=/`;
  document.cookie = cookieString;

  document.cookie = 'userName=' + userName;
  localStorage.setItem('isAuthenticated', 'true');
}

/**
 * Get cookie details
 *
 * @param name for cookie name
 *
 * @returns
 */
export function getCookie(name: string) {
  const value: any = `; ${document.cookie}`;
  const parts: any = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/**
 * Set value in local storage
 *
 * @param authToken for user auth token
 */
export async function setLocalStorage(authToken: string) {
  if (authToken) {
    let decoded: any = await getTokenDetails(authToken);
    if (decoded.custom_token) {
      checkAuthDetails(decoded.custom_token);
    }

    if (decoded.user_details) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userName', decoded.user_details.email);
    }
  } else {
    localStorage.setItem('isAuthenticated', 'false');
    localStorage.setItem('userName', '');
  }
}

/**
 * Get uniq id from url
 *
 * @param hmlData
 *
 * @returns
 */
export function getUniqId(hmlData: string) {
  let identifierDetails: any = '';
  let documentElement: any = getWorkingDom(hmlData);
  try {
    if (
      documentElement &&
      documentElement.querySelector('script[data-name="static-context"]')
    ) {
      const identifierScriptTag: any = documentElement.querySelector(
        'script[data-name="static-context"]'
      );
      const matchId = /"identifier": ?"(.+?)",/g;
      identifierDetails = identifierScriptTag.innerText.match(matchId)[0];
      identifierDetails = identifierDetails.replaceAll('"identifier":"', '');
      identifierDetails = identifierDetails.replaceAll('"', '');
      identifierDetails = identifierDetails.replaceAll(',', '');
    }
  } catch (error) {
    identifierDetails = '';
  }

  return identifierDetails;
}

/**
 * Get title from url
 *
 * @param htmlData
 *
 * @returns
 */
export function getTitle(htmlData: string) {
  let titleInnerName: any = '';
  try {
    let documentElement: any = getWorkingDom(htmlData);
    let title = documentElement.getElementsByTagName('title')[0];
    titleInnerName = title.innerHTML;
  } catch (error) {
    titleInnerName = '';
  }

  return titleInnerName;
}

/**
 * Get dom from html string
 *
 * @param documentElement
 *
 * @returns
 */
export function getWorkingDom(documentElement: string) {
  let htmlDoc: any = '';
  try {
    let parser = new DOMParser();
    htmlDoc = parser.parseFromString(documentElement, 'text/html');
  } catch (error) {
    htmlDoc = '';
  }

  return htmlDoc;
}

export function getAuthenticated() {
  return localStorage.getItem('isAuthenticated');
}

export function setGetUserName(
  email: string = '',
  isSetOrGet: boolean = false
) {
  if (isSetOrGet) {
    localStorage.setItem('userName', email);
  } else {
    return localStorage.getItem('userName');
  }
}

export function setGetUserDetails(
  user: string = null,
  isSetOrGet: boolean = false
) {
  if (isSetOrGet) {
    localStorage.setItem('userDetails', user);
  } else {
    return localStorage.getItem('userDetails');
  }
}

/**
 * Check firebase user auth
 *
 * @param token
 */
const checkAuthDetails = async (token: string) => {
  return true;
};

/**
 * sign with custom user auth
 *
 * @param token for passed custom token
 */
export const signInWithCustomTokenAuth = (token: string) => {
  return true;
};

/**
 * Get token details
 *
 * @param token for user Authenticated token
 *
 * @returns
 */
export function timeConverter(UNIX_timestamp: number, defaultTime = true) {
  if (!UNIX_timestamp) {
    return '';
  }
  let convertDateTime = new Date(UNIX_timestamp);
  let year = convertDateTime.getFullYear();
  let month = convertDateTime.toLocaleString('en-GB', { month: 'long' });
  let date = convertDateTime.getDate();
  let time =
    date +
    ' ' +
    month +
    ' ' +
    year +
    (defaultTime ? `  ${convertDateTime.toLocaleTimeString()}` : '');

  return time;
}

const getTokenDetails = async (token: string) => {
  let userToken: any = {};
  try {
    if (token.indexOf('&') > -1) {
      const customToken = token.split('&')[0];
      const authToken = token.split('&')[1];
      userToken = {
        // user_details: jwt_decode(authToken),
        user_details: await decryptEncryptedJWT(authToken),
        auth_token: authToken,
        custom_token: customToken,
        // custom_details: jwt_decode(customToken)
        custom_details: await decryptEncryptedJWT(customToken)
      };
    } else {
      userToken = {
        // user_details: jwt_decode(token),
        user_details: await decryptEncryptedJWT(token),
        auth_token: token,
        custom_token: '',
        custom_details: ''
      };
    }
  } catch (e) {
    userToken = {
      user_details: '',
      auth_token: '',
      custom_token: '',
      custom_details: ''
    };
  }
  return userToken;
};

/**
 * Set mirror user token cookie
 *
 * @param authToken for token
 */
export function setMirrorCookieString(authToken: string) {
  // const cookieString = 'RoughWaterUserLogging=' + authToken + ';domain=staging.seospace.co.uk;path=/';
  // console.log(cookieString)
  // document.cookie = cookieString;
  if (document.querySelector('#rough-water-seo-root')) {
    const channel = new BroadcastChannel('seo-space');
    channel.postMessage({
      message: 'set_mirror_auth',
      value: { token: authToken }
    });
  }
}

export const decryptEncryptedJWT = async (token) => {
  try {
    const secret = new TextEncoder().encode('09fdf8b6c410c9410aec35749e2edae0');
    const { payload } = await jwtDecrypt(token, secret);
    return payload;
  } catch (err) {
    // console.log('decryptEncryptedJWT error:', err);
    return null;
  }
};
